import React from "react";
import {useOverrides} from "@quarkly/components";
import {Text, Box, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "80px 0",
    "sm-padding": "60px 0",
    "color": "#ffffff",
    "background": "transparent",
    "id": "faq"
};
const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "margin": "0",
            "display": "flex",
            "flex-wrap": "wrap"
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "padding": "16px",
            "width": "30%",
            "lg-width": "100%",
            "lg-margin": "0 0 40px 0"
        }
    },
    "box2": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "as": "h2",
            "font": "--headline1",
            "margin": "0 0 16px 0",
            "color": "#ffffff",
            "font-family": "Plus Jakarta Sans, sans-serif",
            "children": "FAQs"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--lead",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.65)",
            "children": "Нужны ответы? У нас они есть!"
        }
    },
    "box3": {
        "kind": "Box",
        "props": {
            "padding": "0px",
            "width": "70%",
            "lg-width": "100%"
        }
    },
    "box4": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "row",
            "flex-wrap": "wrap",
            "justify-content": "space-between"
        }
    },
    "box5": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box6": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "Нужны ли мне навыки программирования?"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": "Программирование не требуется. Все работает через визуальный интерфейс. Напишите в Telegram для 15-минутной демонстрации."
        }
    },
    "box7": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box8": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "Какие типы торговых стратегий поддерживаются?"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": "Сигнальные стратегии, сеточные стратегии и кастомные алгоритмы. Свяжитесь с поддержкой, чтобы узнать, как они работают в вашем стиле торговли."
        }
    },
    "box9": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box10": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text6": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "Можно ли интегрировать пользовательские индикаторы?"
        }
    },
    "text7": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": "Да. Стандартные и пользовательские индикаторы TradingView работают без проблем. Нужна помощь с интеграцией? Напишите в Telegram поддержку."
        }
    },
    "box11": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box12": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text8": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "Как настроить уведомления?"
        }
    },
    "text9": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": <span>Уведомления в Telegram и интеграция через webhook доступны. Все подробные пошаговые инструкции по настройке вы найдете в нашей <a href="https://docs.cdzv.com/code-zero-visual-trading_ru" target="_blank" rel="noopener noreferrer" style={{ color: "#FD6DF9", textDecoration: "underline", fontWeight: "600" }}>официальной документации</a>.</span>
        }
    }
};

const CdzvFaqRU = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Box {...override("box")}>
            <Box {...override("box1")}>
                <Box {...override("box2")}>
                    <Text {...override("text")} />
                    <Text {...override("text1")} />
                </Box>
            </Box>
            <Box {...override("box3")}>
                <Box {...override("box4")}>
                    <Box {...override("box5")} className="glass-card">
                        <Box {...override("box6")}>
                            <Text {...override("text2")} />
                            <Text {...override("text3")} />
                        </Box>
                    </Box>
                    <Box {...override("box7")} className="glass-card">
                        <Box {...override("box8")}>
                            <Text {...override("text4")} />
                            <Text {...override("text5")} />
                        </Box>
                    </Box>
                    <Box {...override("box9")} className="glass-card">
                        <Box {...override("box10")}>
                            <Text {...override("text6")} />
                            <Text {...override("text7")} />
                        </Box>
                    </Box>
                    <Box {...override("box11")} className="glass-card">
                        <Box {...override("box12")}>
                            <Text {...override("text8")} />
                            <Text {...override("text9")} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvFaqRU, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvFaqRU;